import React from 'react';
import {useMediaQuery} from 'react-responsive';
import {Link} from 'react-router-dom';
import {Dropdown} from 'antd';
import theme from '../theme';
import {getMenuItemsByRoleAndEntity} from "./MenuItems";
import {useUserRole} from "../utils/userSessionUtils";
import {useSelector} from "react-redux";

const AfNavigation = () => {
    const isMobile = useMediaQuery({maxWidth: 768});
    const role = useUserRole();
    const auth = useSelector((state) => state.auth || {});
    const entity = auth.user?.entityId || 0;
    const group = auth.user?.group || "";

    return isMobile ? (
        <div style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            width: '100%',
            background: theme.colors.secondary,
            padding: '15px 0',
            display: 'flex',
            justifyContent: 'space-around',
            boxShadow: '0 -2px 8px rgba(0,0,0,0.15)',
            zIndex: 1000
        }}>
            {getMenuItemsByRoleAndEntity(role, entity, '#000000', group).map(item => {
                // Si tiene children, mostrar dropdown
                if (item.children && item.children.length > 0) {
                    const menuItems = item.children.map(child => ({
                        key: child.key,
                        label: child.label,
                    }));
                    
                    return (
                        <Dropdown 
                            key={item.key}
                            menu={{items: menuItems}}
                            trigger={['click']}
                            placement="topCenter"
                        >
                            <div style={{
                                color: theme.colors.card,
                                textAlign: 'center',
                                fontSize: '18px',
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                cursor: 'pointer'
                            }}>
                                {item.icon}
                                <span style={{fontSize: '12px', marginTop: '4px'}}>{item.labelText}</span>
                            </div>
                        </Dropdown>
                    );
                }
                
                // Si no tiene children, link normal
                return (
                    <Link key={item.key} to={item.path} style={{
                        color: theme.colors.card,
                        textAlign: 'center',
                        fontSize: '18px',
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center'
                    }}>
                        {item.icon}
                        <span style={{fontSize: '12px', marginTop: '4px'}}>{item.labelText}</span>
                    </Link>
                );
            })}
        </div>
    ) : <></>;
};

export default AfNavigation;
